// 域名相关服务
// 直接使用fetch，避免导入问题

// 通用请求函数
async function request(url, options = {}) {
  const defaultOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    }
  }

  const config = { ...defaultOptions, ...options }

  try {
    console.log('发起请求:', url, config)
    const response = await fetch(url, config)

    console.log('响应状态:', response.status, response.statusText)

    if (!response.ok) {
      const errorText = await response.text()
      console.error('HTTP错误响应内容:', errorText)
      throw new Error(`HTTP error! status: ${response.status}, content: ${errorText.substring(0, 200)}`)
    }

    // 检查响应内容类型
    const contentType = response.headers.get('content-type')
    console.log('响应内容类型:', contentType)

    if (!contentType || !contentType.includes('application/json')) {
      const textContent = await response.text()
      console.error('非JSON响应内容:', textContent.substring(0, 500))
      throw new Error(`Expected JSON response but got: ${contentType}. Content: ${textContent.substring(0, 200)}`)
    }

    const data = await response.json()
    console.log('解析的JSON数据:', data)
    return data
  } catch (error) {
    console.error('Request failed:', error)
    throw error
  }
}

// API对象
const api = {
  get baseUrl() {
    return process.env.VUE_APP_API_BASE_URL + '/api'
  },

  async get(endpoint, params = {}) {
    const queryString = new URLSearchParams(params).toString()
    const url = queryString ? `${this.baseUrl}${endpoint}?${queryString}` : `${this.baseUrl}${endpoint}`
    console.log('API GET请求URL:', url)
    return await request(url)
  },

  async post(endpoint, data = {}) {
    const url = `${this.baseUrl}${endpoint}`
    console.log('API POST请求URL:', url)
    return await request(url, {
      method: 'POST',
      body: JSON.stringify(data)
    })
  }
}

/**
 * 域名服务类
 */
class DomainService {
  constructor() {
    this.currentDomain = null
    this.adminInfo = null
    this.customerServiceUrl = null
    this.initialized = false
  }

  /**
   * 初始化域名服务
   */
  async init() {
    // 每次都重新获取，不使用缓存
    try {
      // 获取当前域名
      this.currentDomain = window.location.hostname

      // 清除旧缓存
      localStorage.removeItem('domain_admin_info')
      localStorage.removeItem('current_domain')

      // 获取域名对应的管理员信息
      await this.fetchAdminByDomain()
      this.initialized = true

    } catch (error) {
      console.error('初始化域名服务失败:', error)
      this.initialized = true // 即使失败也标记为已初始化，避免重复尝试
    }
  }

  /**
   * 根据域名获取管理员信息
   */
  async fetchAdminByDomain() {
    try {
      console.log('=== 开始获取域名管理员信息 ===')
      console.log('当前域名:', this.currentDomain)

      const response = await api.get('/domain/admin', {
        domain: this.currentDomain
      })

      console.log('域名管理员API响应:', response)

      if (response && response.success) {
        if (response.data && response.data.admin_id) {
          // 找到了管理员信息
          console.log('找到管理员信息:')
          console.log('- 管理员ID:', response.data.admin_id)
          console.log('- 管理员名称:', response.data.admin_name)
          console.log('- 客服链接:', response.data.customer_service_url)
          console.log('- 绑定域名:', response.data.domains)

          this.adminInfo = response.data
          this.customerServiceUrl = response.data.customer_service_url

          console.log('=== 管理员信息获取成功 ===')
        } else {
          // API成功但没有找到管理员
          console.warn('=== 未找到域名对应的管理员 ===')
          console.warn('域名:', this.currentDomain)
          console.warn('响应数据:', response.data)
          this.adminInfo = null
          this.customerServiceUrl = null
        }
      } else {
        console.error('=== 获取管理员信息API失败 ===')
        console.error('响应:', response)
        this.adminInfo = null
        this.customerServiceUrl = null
      }

    } catch (error) {
      console.error('=== 获取域名管理员信息网络错误 ===')
      console.error('错误详情:', error)
      this.adminInfo = null
      this.customerServiceUrl = null
    }
  }

  /**
   * 获取当前用户的客服链接（需要登录）
   */
  async getCurrentUserCustomerService() {
    try {
      const response = await api.get('/domain/customer-service')

      if (response.success && response.data) {
        this.customerServiceUrl = response.data.customer_service_url
        return response.data
      }

      return null
    } catch (error) {
      console.error('获取用户客服链接失败:', error)
      return null
    }
  }

  /**
   * 获取客服链接
   * @returns {string|null} 客服链接
   */
  getCustomerServiceUrl() {
    return this.customerServiceUrl
  }

  /**
   * 获取管理员信息
   * @returns {object|null} 管理员信息
   */
  getAdminInfo() {
    return this.adminInfo
  }

  /**
   * 获取当前域名
   * @returns {string} 当前域名
   */
  getCurrentDomain() {
    return this.currentDomain
  }

  /**
   * 检查是否有客服链接
   * @returns {boolean} 是否有客服链接
   */
  hasCustomerService() {
    return !!this.customerServiceUrl
  }

  /**
   * 打开客服窗口
   */
  openCustomerService() {
    console.log('域名服务：尝试打开客服窗口')
    console.log('当前客服链接:', this.customerServiceUrl)
    console.log('初始化状态:', this.initialized)

    if (!this.customerServiceUrl) {
      console.warn('域名服务：没有配置客服链接')
      return false
    }

    // 验证客服链接格式
    if (!this.isValidUrl(this.customerServiceUrl)) {
      console.error('域名服务：客服链接格式无效:', this.customerServiceUrl)
      return false
    }

    try {
      console.log('域名服务：创建客服模态窗口')
      // 创建客服窗口
      this.createCustomerServiceModal()
      return true
    } catch (error) {
      console.error('域名服务：打开客服窗口失败:', error)
      // 降级方案：直接打开新窗口
      try {
        console.log('域名服务：使用降级方案打开新窗口')
        window.open(this.customerServiceUrl, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes')
        return true
      } catch (fallbackError) {
        console.error('域名服务：降级方案也失败:', fallbackError)
        return false
      }
    }
  }

  /**
   * 创建客服模态窗口
   */
  createCustomerServiceModal() {
    // 检查是否已存在客服窗口
    const existingModal = document.getElementById('customer-service-modal')
    if (existingModal) {
      existingModal.style.display = 'flex'
      return
    }

    // 创建模态窗口HTML
    const modalHTML = `
      <div id="customer-service-modal" class="customer-service-modal">
        <div class="modal-content">
          <div class="modal-header">
            <h3>客服支持</h3>
            <button class="close-btn" onclick="domainService.closeCustomerService()">&times;</button>
          </div>
          <div class="modal-body">
            <iframe 
              src="${this.customerServiceUrl}" 
              frameborder="0" 
              width="100%" 
              height="100%"
              allow="microphone; camera; geolocation"
            ></iframe>
          </div>
        </div>
      </div>
    `

    // 添加样式
    const style = document.createElement('style')
    style.textContent = `
      .customer-service-modal {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.8);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 10000;
      }
      
      .customer-service-modal .modal-content {
        width: 90%;
        height: 80%;
        max-width: 800px;
        background: white;
        border-radius: 8px;
        overflow: hidden;
        display: flex;
        flex-direction: column;
      }
      
      .customer-service-modal .modal-header {
        padding: 15px 20px;
        background: #4CAF50;
        color: white;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      
      .customer-service-modal .modal-header h3 {
        margin: 0;
        font-size: 18px;
      }
      
      .customer-service-modal .close-btn {
        background: none;
        border: none;
        color: white;
        font-size: 24px;
        cursor: pointer;
        padding: 0;
        width: 30px;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      
      .customer-service-modal .modal-body {
        flex: 1;
        padding: 0;
      }
      
      .customer-service-modal iframe {
        border: none;
      }
      
      @media (max-width: 768px) {
        .customer-service-modal .modal-content {
          width: 95%;
          height: 90%;
        }
      }
    `

    // 添加到页面
    document.head.appendChild(style)
    document.body.insertAdjacentHTML('beforeend', modalHTML)

    // 添加点击背景关闭功能
    const modal = document.getElementById('customer-service-modal')
    modal.addEventListener('click', (e) => {
      if (e.target === modal) {
        this.closeCustomerService()
      }
    })
  }

  /**
   * 关闭客服窗口
   */
  closeCustomerService() {
    const modal = document.getElementById('customer-service-modal')
    if (modal) {
      modal.style.display = 'none'
    }
  }

  /**
   * 验证URL格式
   */
  isValidUrl(url) {
    try {
      new URL(url)
      return true
    } catch (error) {
      return false
    }
  }

  /**
   * 获取调试信息
   */
  getDebugInfo() {
    return {
      initialized: this.initialized,
      currentDomain: this.currentDomain,
      customerServiceUrl: this.customerServiceUrl,
      adminInfo: this.adminInfo,
      hasCustomerService: this.hasCustomerService()
    }
  }

  /**
   * 清除缓存
   */
  clearCache() {
    localStorage.removeItem('domain_admin_info')
    localStorage.removeItem('current_domain')
    this.adminInfo = null
    this.customerServiceUrl = null
    this.initialized = false
  }
}

// 创建全局实例
const domainService = new DomainService()

// 挂载到window对象，供HTML中的onclick使用
window.domainService = domainService

export default domainService
